var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossFilterBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6177 16.3979C18.957 14.0586 18.957 10.2519 16.6177 7.91263C14.2784 5.57335 10.4717 5.57335 8.13245 7.91263L7.07178 6.85197C9.99603 3.92773 14.7541 3.92773 17.6784 6.85197C20.6026 9.77621 20.6026 14.5343 17.6784 17.4586C14.7541 20.3828 9.99603 20.3828 7.07178 17.4586L8.13245 16.3979C10.4717 18.7372 14.2779 18.7377 16.6177 16.3979ZM4.50001 11.7499C4.50001 11.4738 4.72387 11.2499 5.00001 11.2499L6.75001 11.2499L6.75001 10.7499C6.75001 10.3379 7.22039 10.1027 7.55001 10.3499L9.75001 11.9999C9.86952 12.072 8.45348 13.0769 7.52541 13.7191C7.19597 13.947 6.75001 13.71 6.75001 13.3094L6.75001 12.7499H5.00001C4.72387 12.7499 4.50001 12.5261 4.50001 12.2499V11.7499ZM10.2538 10.034C11.4237 8.86404 13.327 8.86457 14.4964 10.034C15.6658 11.2033 15.6663 13.1067 14.4964 14.2766C13.3265 15.4465 11.4231 15.446 10.2538 14.2766L9.19311 15.3373C10.948 17.0921 13.8022 17.0921 15.5571 15.3373C17.3119 13.5824 17.3119 10.7282 15.5571 8.97329C13.8022 7.21843 10.948 7.21843 9.19311 8.97329L10.2538 10.034Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFilterBadge);
export default ForwardRef;